import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

type BadgeProps = {
    children: React.ReactNode;
    type?: 'neutral' | 'alert' | 'pill';
    size?: 'small-heavy' | 'medium-regular' | 'medium-heavy';
    interactive?: boolean;
    letterCase?: 'uppercase' | 'capitalize';
};

export const Badge: FunctionComponent<BadgeProps> = props => {
    const { children, type, size, interactive, letterCase } = props;
    const isPill = type === 'pill';
    const isSmallSize = !size || size === 'small-heavy';

    const badgePillClasses = isPill
        ? {
              [styles.badgePill]: true,
              [styles.badgeMedium]: size === 'medium-regular' || size === 'medium-heavy',
              [styles.badgeInteractive]: !!interactive,
          }
        : null;

    const badgeInnerPillClasses = isPill
        ? {
              [styles.badgeInnerPill]: true,
              [styles.badgeInnerSmallHeavy]: size === 'small-heavy',
              [styles.badgeInnerMediumRegular]: size === 'medium-regular',
              [styles.badgeInnerMediumHeavy]: size === 'medium-heavy',
              [styles.badgeInnerUppercase]: isSmallSize && letterCase === 'uppercase',
              [styles.badgeInnerCapitalize]: isSmallSize && letterCase === 'capitalize',
          }
        : null;

    const badgeClasses = classnames(
        styles.badge,
        {
            [styles.badgeNeutral]: type === 'neutral',
            [styles.badgeAlert]: type === 'alert',
        },
        badgePillClasses
    );

    const badgeInnerClasses = classnames(styles.badgeInner, badgeInnerPillClasses);

    return (
        <div className={badgeClasses}>
            <div className={badgeInnerClasses}>{children}</div>
        </div>
    );
};
